/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedTeachers200,
  GetApiV1ClassroomdisciplineSharedTeachers401,
  GetApiV1ClassroomdisciplineSharedTeachersQueryParams,
  GetApiV1ClassroomdisciplineSharedTeachersQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedTeachers.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedTeachersQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedTeachersQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedTeachers200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedTeachers200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedTeachers401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedTeachers401>;

export const getApiV1ClassroomdisciplineSharedTeachersQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedTeachers200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedTeachersQueryResponse>;
